





import { Vue, Component } from 'vue-property-decorator';


@Component
export default class MandalaReport extends Vue {
  get urlReport() {
    return this.$route.query.reportUrl;
  }
}
